module.exports = function(app) {
	app.directive('eprCollapsibleRow', [function() {
		return {
			restrict: 'A',
			replace: false,
			transclude: true,
			template: require('directives/common/eprCollapsibleRow.html'),

			scope: {
				open: '=eprCollapsibleRow',
				buttonText: '@',
				onOpen: '&?'
			},

			controller: ['$scope', function($scope) {
				if ($scope.onOpen) {
					$scope.$watch('open', function(n, o) {
						if (n) { $scope.onOpen(); }
					});
				}
			}]
		};
	}]);
};
